import type { CalendarEvent, CalendarTag } from '../../types/calendar';

/** Untagged events take the app's purple accent rather than a category colour. */
export const DEFAULT_EVENT_COLOR = '#7D45FF';

export type TagColorLookup = ReadonlyMap<string, string>;

const tagsOf = (event: CalendarEvent): CalendarTag[] => {
  const tags = (event as { tags?: unknown }).tags;
  return Array.isArray(tags) ? (tags as CalendarTag[]) : [];
};

/** The colour of an event's first tag, or the default when it has none. */
export function eventColor(event: CalendarEvent, tagColors: TagColorLookup): string {
  const first = tagsOf(event)[0];
  if (!first) return DEFAULT_EVENT_COLOR;
  return tagColors.get(first.id) || first.color || DEFAULT_EVENT_COLOR;
}

/**
 * `#rgb` / `#rrggbb` at the given alpha. Tag colours are hex, but anything
 * else passes through opaque rather than producing an invalid value.
 */
export function tint(color: string, alpha: number): string {
  const hex = color.trim().replace(/^#/, '');
  const full = hex.length === 3 ? hex.split('').map(c => c + c).join('') : hex;
  if (!/^[0-9a-f]{6}$/i.test(full)) return color;
  const r = parseInt(full.slice(0, 2), 16);
  const g = parseInt(full.slice(2, 4), 16);
  const b = parseInt(full.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
